import React, { useRef } from 'react';

function OtpCodeInput({ value, onChange, disabled = false }) {
  const inputRefs = useRef([]);
  const digits = Array.from({ length: 6 }, (_, index) => value[index] || '');

  const updateDigits = (nextDigits) => onChange(nextDigits);

  const handleChange = (index, inputValue) => {
    const enteredDigits = inputValue.replace(/\D/g, '');
    const nextDigits = [...digits];

    if (!enteredDigits) {
      nextDigits[index] = '';
      updateDigits(nextDigits);
      return;
    }

    enteredDigits.slice(0, 6 - index).split('').forEach((digit, offset) => {
      nextDigits[index + offset] = digit;
    });
    updateDigits(nextDigits);
    inputRefs.current[Math.min(index + enteredDigits.length, 5)]?.focus();
  };

  const handlePaste = (event) => {
    const pastedDigits = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
    if (!pastedDigits) return;
    event.preventDefault();
    updateDigits(Array.from({ length: 6 }, (_, index) => pastedDigits[index] || ''));
    inputRefs.current[Math.min(pastedDigits.length, 5)]?.focus();
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !digits[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (event.key === 'ArrowLeft' && index > 0) inputRefs.current[index - 1]?.focus();
    if (event.key === 'ArrowRight' && index < 5) inputRefs.current[index + 1]?.focus();
  };

  return (
    <div role="group" aria-label="Six-digit verification code" className="grid grid-cols-6 gap-2">
      {digits.map((digit, index) => (
        <input
          key={index}
          ref={(element) => { inputRefs.current[index] = element; }}
          type="text"
          inputMode="numeric"
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
          aria-label={`Verification digit ${index + 1}`}
          value={digit}
          onChange={(event) => handleChange(index, event.target.value)}
          onKeyDown={(event) => handleKeyDown(index, event)}
          onPaste={handlePaste}
          disabled={disabled}
          className="h-12 min-w-0 rounded-xl border border-slate-300 bg-white text-center text-lg font-semibold text-slate-900 outline-none transition focus:border-orange-500 focus:ring-2 focus:ring-orange-100 disabled:bg-slate-100"
        />
      ))}
    </div>
  );
}

export default OtpCodeInput;